import Vue from 'vue'
import Vuex from 'vuex'
import { IAppState } from './modules/app'
import { IUserState } from './modules/user'
import { ITagsViewState } from './modules/tags-view'
import { IErrorLogState } from './modules/error-log'
import { IPermissionState } from './modules/permission'
import { ISettingsState } from './modules/settings'

import { IClientsState } from './modules/clients'
import { IProductsState } from './modules/products'

import { IInspectorsState } from './modules/inspectors'
import { IOrdersState } from './modules/orders'
import { IVendorsState } from './modules/vendors'
import { IVendorCompaniesState } from './modules/vendorCompanies'
import { IVendorCoverageSetsState } from './modules/vendorCoverageSets'
import { IVendorLicenseTypesState } from './modules/vendorLicenseTypes'
import { IVendorRolesState } from './modules/vendorRoles'
import { IVendorStatusesState } from './modules/vendorStatuses'
import { IVendorTypesState } from './modules/vendorTypes'

import { IFipStates } from './modules/fipStates'
import { IFipCounties } from './modules/fipCounties'
import { IFipZips } from './modules/fipZips'
import { IAdminState } from './modules/admin'

Vue.use(Vuex)

export interface IRootState {
  app: IAppState
  clientsState: IClientsState
  productsState: IProductsState
  user: IUserState
  admin: IAdminState
  tagsView: ITagsViewState
  errorLog: IErrorLogState
  inspectorsState: IInspectorsState
  orders: IOrdersState
  permission: IPermissionState
  settings: ISettingsState
  vendors: IVendorsState
  vendorCompanies: IVendorCompaniesState
  vendorCoverageSets: IVendorCoverageSetsState
  vendorLicenseTypes: IVendorLicenseTypesState
  vendorRoles: IVendorRolesState
  vendorStatuses: IVendorStatusesState
  vendorTypes: IVendorTypesState
  fipStates: IFipStates
  fipCounties: IFipCounties
  fipZips: IFipZips
}

// Declare empty store first, dynamically register all modules later.
export default new Vuex.Store<IRootState>({
  devtools: true
})
